import React from "react";

type Props = {};

const Events: React.FC<Props> = () => (
  <div className="text-[50px] text-center">
    <h1>This is Events page</h1>
  </div>
);

export default Events;
